<ion-toolbar class="main-header-toolbar">
    <app-header></app-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
                   (ionRefresh)="refresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <!--refresher end-->

    <ion-grid fixed class="grid-md">

        <ion-row class="white-bg-wrapper">
            <ion-col size="12" class="ion-justify-content-start">
                <div class="top-wrapper">
                    <div class="back" [routerLink]="'/home'">
                        <img alt="back" src="assets/images/icons/arrow_left_green.svg"/>
                        {{ 'btnBack'|transloco }}
                    </div>

                    <div class="page-title">
                        {{ 'faq'|transloco }}
                    </div>


                    <div class="accordion-wrapper" *ngIf="faqs != undefined">
                        <ion-accordion-group (ionChange)="onAccordionChange($event)"  #accordionGroup>
                            <ion-accordion value="{{j}}" *ngFor="let item of this.faqs; let j = index" class="faq-item">
                                <ion-item slot="header" class="title">
                                    <ion-label [innerHTML]="item.title" > </ion-label>
                                    <img
                                        [src]="currentAccordion == j ? 'assets/images/icons/circular-with-minus.svg' : 'assets/images/icons/circular-with-plus.svg'"
                                        class="ion-accordion-toggle-icon"
                                        alt="arrow">
                                </ion-item>


                                <div class="ion-padding content" slot="content"
                                     [innerHTML]="item.content"
                                >
                                </div>
                            </ion-accordion>

                        </ion-accordion-group>
                    </div>





                </div>


            </ion-col>

        </ion-row>

    </ion-grid>
    <app-footer></app-footer>

</ion-content>
<app-chats></app-chats>
